export const rebind = (object) => {
  // 実際に動かないケースが出たら、以下を試してみる

  // tooltip
  // var tooltipTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle='tooltip']"));
  // tooltipTriggerList.map(function (tooltipTriggerEl) {
  //   return new window.components.tooltip(tooltipTriggerEl);
  // });

  // popover;
  // var popoverTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle='popover']"));
  // popoverTriggerList.map(function (popoverTriggerEl) {
  //   return new window.components.popover(popoverTriggerEl, { trigger: "focus" });
  // });

  // validator
  if (window.components.validator) {
    window.components.validator.rebind();
  }

  // if value
  if (window.components.switcherIfValue) {
    $(".jsIfValue").each(() => {
      window.components.switcherIfValue.setup($(this));
    });
  }

  // toggle switch
  if (window.components.toggleSwitch) {
    $(".form-switch").each((index, element) => {
      window.components.toggleSwitch.setup(element);
    });
  }
};
